import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/lib/site";
import { ImageSlot } from "@/components/ImageSlot";
import { Reveal } from "@/components/Reveal";

export const RelatedServices = ({ related }) => (
  <section data-testid="related-services" aria-labelledby="related-heading" className="section bg-white">
    <div className="container-site">
      <Reveal className="max-w-[720px]">
        <h2 id="related-heading">Related Services</h2>
        <p className="sub-line mt-4 text-body">Jobs that often go hand in hand with this one.</p>
      </Reveal>
      <ul className="mt-12 grid gap-6 md:grid-cols-3">
        {related.map((r, i) => {
          const s = SERVICES.find((x) => x.id === r.id);
          return (
            <Reveal as="li" key={r.id} delay={i * 60}>
              <Link
                to={s.to}
                data-testid={`related-service-${s.id}`}
                className="card group flex h-full flex-col overflow-hidden transition-[border-color] duration-200 hover:border-brand"
              >
                <ImageSlot label={s.slot.id} note={s.slot.note} ratio="4:3" alt={s.alt} imgClassName="transition-transform duration-300 ease-out group-hover:scale-[1.02]" />
                <div className="flex flex-1 flex-col p-6">
                  <h3>{s.title}</h3>
                  <p className="mt-2 text-base text-body">{r.blurb}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[15px] font-semibold text-brand">
                    {r.anchor}
                    <ArrowRight size={18} aria-hidden="true" className="transition-transform duration-200 ease-out group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);
